let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2wFoP")).then(() => parcelRequire('cs9Eu'));